export interface DeviceCapabilities {
  deviceMemoryGb: number | null;
  hardwareConcurrency: number | null;
  saveData: boolean | null;
}

type NavigatorWithCapabilityHints = Navigator & {
  deviceMemory?: number;
  connection?: { saveData?: boolean };
};

const LOW_END_DEVICE_MEMORY_GB = 4;
const LOW_END_HARDWARE_CONCURRENCY = 4;

const currentNavigator = (): NavigatorWithCapabilityHints | null =>
  typeof navigator === "undefined" ? null : navigator;

export const readDeviceCapabilities = (
  navigatorLike: NavigatorWithCapabilityHints | null = currentNavigator()
): DeviceCapabilities => {
  if (!navigatorLike) {
    return { deviceMemoryGb: null, hardwareConcurrency: null, saveData: null };
  }
  return {
    deviceMemoryGb: typeof navigatorLike.deviceMemory === "number" ? navigatorLike.deviceMemory : null,
    hardwareConcurrency:
      typeof navigatorLike.hardwareConcurrency === "number" ? navigatorLike.hardwareConcurrency : null,
    saveData: typeof navigatorLike.connection?.saveData === "boolean" ? navigatorLike.connection.saveData : null,
  };
};

export const isLowEndDevice = ({ deviceMemoryGb, hardwareConcurrency, saveData }: DeviceCapabilities): boolean => {
  if (saveData === true) {
    return true;
  }
  if (deviceMemoryGb === null) {
    return false;
  }
  if (deviceMemoryGb <= LOW_END_DEVICE_MEMORY_GB) {
    return true;
  }
  return hardwareConcurrency !== null && hardwareConcurrency <= LOW_END_HARDWARE_CONCURRENCY;
};
